import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { WorkspaceData } from '../../types/auth.types';

interface WorkspaceState {
    workspaces: WorkspaceData[];
    activeWorkspaceId: string | null;
    activeWorkspace: WorkspaceData | null;
    loading: boolean;
    error: string | null;
}

const initialState: WorkspaceState = {
    workspaces: [],
    activeWorkspaceId: null,
    activeWorkspace: null,
    loading: false,
    error: null,
};

const workspaceSlice = createSlice({
    name: 'workspace',
    initialState,
    reducers: {
        setWorkspaces: (state, action: PayloadAction<WorkspaceData[]>) => {
            state.workspaces = action.payload;
            
            // Find the active workspace if it exists
            const activeWorkspace = action.payload.find(ws => ws.is_active);
            if (activeWorkspace) {
                state.activeWorkspace = activeWorkspace;
                state.activeWorkspaceId = activeWorkspace.id;
            }
        },
        setActiveWorkspace: (state, action: PayloadAction<WorkspaceData>) => {
            state.activeWorkspace = action.payload;
            state.activeWorkspaceId = action.payload.id;
            
            // Update is_active flag in the workspaces array
            state.workspaces = state.workspaces.map(workspace => ({
                ...workspace,
                is_active: workspace.id === action.payload.id
            }));
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload;
        },
        clearWorkspaceState: (state) => {
            // Reset to initial state
            state.workspaces = [];
            state.activeWorkspaceId = null;
            state.activeWorkspace = null;
            state.loading = false;
            state.error = null;
        }
    },
    // Add extraReducers to listen for auth/logout action
    extraReducers: (builder) => {
        builder.addCase('auth/logout', (state) => {
            // Reset to initial state when user logs out
            state.workspaces = [];
            state.activeWorkspaceId = null;
            state.activeWorkspace = null;
            state.loading = false;
            state.error = null;
        });
    }
});

export const { 
    setWorkspaces, 
    setActiveWorkspace, 
    setLoading, 
    setError, 
    clearWorkspaceState 
} = workspaceSlice.actions;

export default workspaceSlice.reducer; 